import { useState, useEffect } from "react";
import { useAppSelector } from "../../Redux/store";
import { calculateByteSize } from "../../helpers/bytes";

export const BytesDisplay: React.FC = () => {
    const [byteSize, setByteSize] = useState<number>(0);

    const { codeSrc } = useAppSelector(state => state.developerSandbox);

    useEffect(() => {
        setByteSize(calculateByteSize(codeSrc))
    }, [codeSrc])

    return (
        <p className='interactions-text text-right m-0 text-sm'>
            {`${byteSize} bytes (${byteSize / 1000} kb)`}
        </p>
    );
}
